import { useIntl } from "react-intl";

const ExternalCustomerSSO = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ExternalCustomerSSO.header",
            defaultMessage: "External customer SSO (single sign-on)"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ExternalCustomerSSO.body",
            defaultMessage:
                "SSO (single sign-on) for external accounts lets your customers get help in Jira Service Management without having to log in."
        })
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default ExternalCustomerSSO;
